import * as React from 'react'
import { Image } from 'cnx-designer'
import { Editor } from 'slate'
import ToolGroup from '../ToolGroup'
import MediaAttribute from '../MediaAttribute'
import { OnToggle } from '../../index'
import { useCurrentSelection } from '../../../../../../../screens/app/Draft/withCurrentSelection'

interface ImageToolsProps {
  toggleState: boolean
  editor: Editor
  onToggle: OnToggle
}

const ImageTools = ({ toggleState, editor, onToggle }: ImageToolsProps) => {
  const selection = useCurrentSelection()

  const node = Editor.above(editor, { at: selection, match: Image.isImage })
  if (!node) return null

  return (
    <ToolGroup
      title="editor-tools-image-title"
      toggleState={toggleState}
      className="image-tools"
      onToggle={() => onToggle('imageTools')}
    >
      <MediaAttribute node={node} attribute="intendedUse" />
    </ToolGroup>
  )
}

export default ImageTools
